document.addEventListener("DOMContentLoaded", function () {
  const boxes = document.querySelectorAll(".description-column");
  if (!boxes.length) return;

  const startColors = ["#001428", "#000714"];
  const endColors = ["#00d8ec", "#001428"];
  const duration = 300;
  let animationFrameMap = new WeakMap();

  function hexToRgb(hex) {
    const bigint = parseInt(hex.slice(1), 16);
    return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
  }

  function rgbToHex([r, g, b]) {
    return "#" + [r, g, b].map(x => x.toString(16).padStart(2, "0")).join("");
  }

  function interpolateColor(start, end, t) {
    return start.map((startVal, i) =>
      Math.round(startVal + (end[i] - startVal) * t)
    );
  }

  function animateGradient(el, reverse = false) {
    const fromColors = reverse ? endColors : startColors;
    const toColors = reverse ? startColors : endColors;
    const fromRGB = fromColors.map(hexToRgb);
    const toRGB = toColors.map(hexToRgb);

    const startTime = performance.now();

    function animate(time) {
      let t = Math.min((time - startTime) / duration, 1);
      const currentColors = fromRGB.map((startRGB, i) =>
        rgbToHex(interpolateColor(startRGB, toRGB[i], t))
      );

      // Only this line changed: added % positions to define where the gradient stops
      el.style.background = `linear-gradient(to bottom, ${currentColors[0]} 0%, ${currentColors[1]} 33%)`;

      if (t < 1) {
        const frame = requestAnimationFrame(animate);
        animationFrameMap.set(el, frame);
      }
    }

    cancelAnimationFrame(animationFrameMap.get(el));
    const frame = requestAnimationFrame(animate);
    animationFrameMap.set(el, frame);
  }

  boxes.forEach(el => {
    el.addEventListener("mouseenter", () => {
      el.style.boxShadow = "0px 0px 2px rgba(0, 216, 236, 0.4)";
      animateGradient(el, false);
    });

    el.addEventListener("mouseleave", () => {
      el.style.boxShadow = "none";
      animateGradient(el, true);
    });
  });
});
